module.exports = __webpack_public_path__ + "static/media/Trinidad Dr, Tiburon, CA7.e36d96e8.jpg";